var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['goods-order-states']},[_c('wt-steps',{attrs:{"steps":_vm.steps,"alignCenter":true,"active":_vm.stepsActive,"stepTitle":"name","description":"happen_time"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }